import { IBookmarkTradeData } from 'src/model/bookmark';
import { Grid } from '@mui/material';
import TradeBookmarkCard from 'src/features/Bookmark/TradeDataBookmarkList/TradeBookmarkCard';

interface IListTradeDataBookmarkProps {
  listBookmark: IBookmarkTradeData[];
}

const TradeDataBookmarkList = ({ listBookmark }: IListTradeDataBookmarkProps) => {
  return (
    <Grid container spacing={2}>
      {listBookmark.map((dataBookmark: IBookmarkTradeData, index) => {
        return (
          <Grid xs={12} md={6} lg={6} xl={4} key={`trade-data-bookmark-${dataBookmark.uuid}-${index}`} item>
            <TradeBookmarkCard dataBookmark={dataBookmark} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TradeDataBookmarkList;
